// ======================================================================
// File Name       : usageStatus
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as actionTypes from '../constants/ActionTypes';

const initialState = {
    maxIdTotalNum: 0,
    maxMultiLanguageDocumentPage: 0,
};

export default function noticeTop(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_CURRENT_USAGE_STATUS:
        { const { responseData } = action;
        const {maxIdTotalNum, maxMultiLanguageDocumentPage} = responseData;
        return { ...state, maxIdTotalNum, maxMultiLanguageDocumentPage}; }
    default:
      return state;
  }
}
